// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as PervasivesU from "rescript/lib/es6/pervasivesU.js";
import * as LibraryImageFallback$GameDataCore from "../LibraryImageFallback.res.mjs";

function attrOpt(el, name) {
  var other = el.getAttribute(name);
  var other$1 = (other == null) ? undefined : Caml_option.some(other);
  if ((other == null) || other !== "") {
    return other$1;
  }
  
}

function mounted() {
  var self = this ;
  var container = self.el;
  var containerId = container.id;
  var el = container.querySelector("#" + containerId + "-library");
  var libraryEl = (el == null) ? PervasivesU.failwith("Library image element not found within container " + containerId) : el;
  var origin = location.origin;
  var queue = LibraryImageFallback$GameDataCore.buildFallbackQueue(attrOpt(container, "data-app-id"), attrOpt(container, "data-poster-image-src"), attrOpt(container, "data-capsule-image-v5-src"), attrOpt(container, "data-capsule-image-src"), attrOpt(container, "data-header-image-src"), attrOpt(container, "data-icon-url-src"), origin);
  self.libraryImage = libraryEl;
  self.fallbackQueue = queue;
  self.triedSources = [];
  libraryEl.classList.remove("opacity-0");
  var onErr = function (_event) {
    var img = self.libraryImage;
    var current = LibraryImageFallback$GameDataCore.normalizeSrc(img.src, origin);
    var triedCopy = self.triedSources.concat([current]);
    self.triedSources = triedCopy;
    var nextSrc = self.fallbackQueue.find(function (src) {
          return !LibraryImageFallback$GameDataCore.hasSrc(triedCopy, LibraryImageFallback$GameDataCore.normalizeSrc(src, origin));
        });
    if (nextSrc !== undefined) {
      var cl = img.classList;
      cl.remove("opacity-0");
      cl.remove("blur");
      cl.remove("object-contain");
      cl.remove("bg-elevation-1");
      cl.add("object-cover");
      if (!LibraryImageFallback$GameDataCore.isLibraryPortrait(nextSrc)) {
        cl.remove("object-cover");
        cl.add("object-contain");
        cl.add("bg-elevation-1");
      }
      img.src = nextSrc;
      return ;
    }
    img.classList.add("opacity-0");
  };
  self.onError = onErr;
  libraryEl.addEventListener("error", onErr);
}

function destroyed() {
  var self = this ;
  self.libraryImage.removeEventListener("error", self.onError);
}

var libraryImageFallback = {
  mounted: mounted,
  destroyed: destroyed
};

export {
  attrOpt ,
  mounted ,
  destroyed ,
  libraryImageFallback ,
}
/* mounted Not a pure module */
